
import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Typography,
    LinearProgress,
    Button,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio,
    IconButton,
    Checkbox,
} from "@mui/material";
import { CancelOutlined } from "@mui/icons-material";

function ReadBrief({ newBrief,handleClose, title }: any) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [activeMenu, setActiveMenu] = useState<"brief" | "quiz">("brief");
    const [currentSection, setcurrentSection] = useState<any>()
    console.log("Hello")
    useEffect(() => {
        newBrief && setcurrentSection(newBrief[currentIndex])
    }, [newBrief, currentIndex])
    const nextSection = () => {
        if (currentIndex < newBrief.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
        else {
                handleClose();
                return;
        }
    };

    const prevSection = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        }
    };

    return (
        <Box className='h-100 w-100 p-2' sx={{ background: '#E3DDD1' }}>
            <Box className='d-flex h-100'>
                <Box
                    className='p-3 border-10'
                    sx={{
                        width: '25%',
                        maxWidth: "300px",
                        bgcolor: "#ADB792",
                        p: 2,
                        overflowY: "auto",
                    }}
                >
                    {/* <Typography variant="h5" className="fw-bold mb-2">
                        Mysterey
                        <br />
                        Management
                    </Typography>

                    <Typography variant="body2">Mission Brief</Typography> */}

                    {newBrief?.map((section: any, index: number) => (
                        <Box
                            key={index}
                            onClick={() => {
                                setCurrentIndex(index);
                                setActiveMenu("brief");
                            }}
                            className='border-10 p-2 px-3 mb-2'
                            sx={{
                                cursor: "pointer",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                bgcolor:
                                    (currentIndex === index && activeMenu === "brief")
                                        ? "#fff"
                                        : "transparent",
                            }}
                        >
                            <Box className='d-flex align-items-center' gap={1}>
                                <Box className='d-flex align-items-center border-10' p={1} bgcolor={currentIndex == index ? "#000000" : "#0000001A"} height={'fit-content'}>
                                    <img src={section?.iconImage}  width={'20px'} alt="" />
                                </Box>
                                <Typography fontWeight={500}>
                                    {section?.title}
                                </Typography>
                            </Box>

                            <Typography color="#777">
                                {(index + 1).toString().padStart(2, "0")}
                            </Typography>
                        </Box>
                    ))}
                </Box>

                {/* Main */}
                <Box flex={1} className='d-flex flex-column p-3 overflow-hidden h-100' gap={2}>
                    {/* Header */}
                    <Box
                        className='py-2 border-bottom w-100'>
                        <Box className='d-flex justify-content-between'>
                            <Typography
                                variant="h4"
                                className="m-0 p-0"
                                fontWeight={600}
                            >
                                {title}
                            </Typography>
                            <IconButton onClick={() => {handleClose()}}>
                                <CancelOutlined />
                            </IconButton>
                        </Box>

                        {activeMenu === "brief" && (
                            <Box mt={2}>
                                <Typography mb={1}>
                                    Reading {currentIndex + 1} of {newBrief?.length}
                                </Typography>
                                <LinearProgress
                                    variant="determinate"
                                    value={
                                        ((currentIndex + 1) /
                                            newBrief?.length) *
                                        100
                                    }
                                    sx={{
                                        height: 8,
                                        borderRadius: 10,
                                        backgroundColor: "#fff",
                                        "& .MuiLinearProgress-bar": {
                                            backgroundColor: "#ADB792",
                                        },
                                    }}
                                />
                            </Box>
                        )}
                    </Box>


                    <Box
                        className='h-100'
                        sx={{
                            width: "100%",
                            maxHeight: '100%',
                            overflowY: 'auto',
                            bgcolor: "#fff",
                            borderRadius: '20px',
                            p: 3,
                            boxShadow: "0 5px 20px rgba(0,0,0,.08)",
                        }}
                    >
                                <Box className='d-flex align-items-start' gap={2}>
                                    <Box sx={{
                                        display: "flex",
                                        alignItems: 'center',
                                        gap: 2,
                                        mb: 2,
                                        bgcolor: currentSection?.toneColor,
                                        width: 'fit-content',
                                        borderRadius: "50px",
                                        px: 1.5,
                                        py: 1.5,
                                    }}>
                                        <img src={currentSection?.iconImage} height={'25px'} width={'25px'} alt="" />
                                        {/* <Box
                                        sx={{
                                            fontSize: '12px',
                                        }}
                                    >
                                        {currentSection?.iconName ?? "Caption"}
                                    </Box> */}

                                        {/* <Typography variant="body2" color="#666">
                                        Section {(currentIndex + 1)
                                            .toString()
                                            .padStart(2, "0")} / {newBrief?.length}
                                    </Typography> */}
                                    </Box>
                                    <Typography variant="h3" className="fw-medium mb-3" fontFamily={'"Instrument Serif", serif !important'}>
                                        {currentSection?.title}
                                    </Typography>
                                </Box>


                                <Box
                                    className='custom-html'
                                    dangerouslySetInnerHTML={{
                                        __html: currentSection?.description,
                                    }}
                                />
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                            <>
                                <Button
                                    onClick={prevSection}
                                    disabled={currentIndex === 0}
                                    variant="outlined"
                                    sx={{border:'1px solid #75724C', color:'#75724C !important'}}
                                    // className="button-secondary-outlined py-2 px-5"
                                >
                                    Previous
                                </Button>

                                <Button
                                    onClick={nextSection}
                                    variant="contained"
                                    className="table-row-background"
                                    sx={{p:"8px 30px"}}
                                >
                                    {currentIndex + 1 === newBrief?.length
                                        ? "Finish"
                                        : "Next Section"}
                                </Button>
                            </>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default ReadBrief;
